import styled from "styled-components";

export const Page = styled.div`
    height: 100vh;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    /* Hide the desktopLogo in the Studio Monitor */
    .desktopLogo {
        display: none !important; /* Hide completely */
    }

    /* Simplified styling for welComeLogo */
    .welComeLogo {
        /* Just ensure it doesn't get affected by other styles */
        position: relative !important;
    }

    .studioMonitorLogo {
        position: absolute;
        top: ${props => props.theme.spacing.main};
        left: 50%;
        transform: translateX(-50%);
        width: 548px;
        height: auto;
        z-index: 10;
    }

    .mrBottomExtraLarge {
        margin-bottom: ${props => props.theme.spacing.extraLarge};
    }
    .mrBottomLarge {
        margin-bottom: ${props => props.theme.spacing.large};
    }
    
    .mrBottomMain {
        margin-bottom: ${props => props.theme.spacing.main};
    }

    .mrBottomSmall {
        margin-bottom: ${props => props.theme.spacing.small};
    }
    .mrBottom100 {
        margin-bottom: 100px;
    }
    .mrRightMain: {
        margin-right: ${props => props.theme.spacing.main};
    }
    .studioBigButton {
        height: 70px;
        width: 547px;
        font-size: 38.5px;
    }
    
    .bottomGradient {
        width: 100%;
        height: 317px;
        bottom: 0;
        background: linear-gradient(5deg, rgba(15, 20, 32, 0.50) 19.72%, rgba(0, 0, 0, 0.00) 56.27%);
        position: absolute;
    }
`;